// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"ThemeButton_preserveOutline__odCYb","button":"ThemeButton_button__5vSeW ThemeButton_preserveOutline__odCYb","svg":"ThemeButton_svg__3m7UZ"};